export default function workspaceProducerName(state) {
  return state.workspaceProducerId && state.workspaceProducerId.name;
}
